import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {STATUS_DISLIKE, STATUS_LIKE} from '../library/intranet/likeHandler';
import {toInt} from '../library/math';
import {addCalendarRoutes} from './calendar';

const AppointmentCalendarEdit       = () => import('../views/appointment/calendar/AppointmentCalendarEdit.vue');
const AppointmentOpenInvites        = () => import('../views/appointment/AppointmentOpenInvites.vue');
const AppointmentDeclinedInvites    = () => import('../views/appointment/AppointmentDeclinedInvites.vue');
const AppointmentEntryEdit          = () => import('../views/appointment/entry/AppointmentEntryEdit.vue');
const AppointmentEntryView          = () => import('../views/appointment/entry/AppointmentEntryView.vue');
const AppointmentSettings           = () => import('../views/appointment/settings/AppointmentSettings.vue');
const AppointmentSettingsGlobal     = () => import('../views/appointment/settings/AppointmentSettingsGlobal.vue');
const VisitorList                   = () => import('../views/appointment/visitorList/VisitorList.vue');
const VisitorListView               = () => import('../views/appointment/visitorList/VisitorListView.vue');
const VisitorListSettings           = () => import('../views/appointment/visitorList/VisitorListSettings.vue');
const CategoryManagement            = () => import('../components/CategoryManagement.vue');

export const availableVisitorListModules = ['global', 'enrolment'];

const meta: MetaData = {
    module: 'appointment',
};

let routes: RouteRecordRaw[] = [
    // appointment
    {
        name: 'appointment-entry-view-invite',
        path: '/appointment/entry/invite/:id/:start(\\d{4}-\\d{2}-\\d{2})?/:decision(0|1)',
        alias: [
            '/appointment/entry/invite/id/:id/start/:start?/decision/:decision/mail/1',
            '/appointment/entry/invite/id/:id/decision/:decision/mail/1',
            '/appointment/entry/invite/id/:id/start/:start?/decision/:decision',
        ],
        component: AppointmentEntryView,
        props(route: RouteLocationStringParam)
        {
            return {
                resource: 'appointment',
                id: parseInt(route.params.id),
                start: route.params.start || '',
                decision: parseInt(route.params.decision) ? STATUS_LIKE : STATUS_DISLIKE,
            };
        },
        meta,
    },
    {
        name: 'appointment-entry-find',
        component: AppointmentEntryEdit,
        path: '/appointment/entry/find/:calendar?/:start?/:end?/:allDay?',
        props(route: RouteLocationStringParam)
        {
            return {
                resource: 'appointment',
                calendar: toInt(route.params.calendar),
                find: true,
            };
        },
        meta,
    },
    {
        name: 'appointment-open-invites',
        path: '/appointment/open-invites',
        component: AppointmentOpenInvites,
        props(route: RouteLocationStringParam)
        {
            return {
                resource: 'appointment',
                id: parseInt(route.params.id),
                start: route.params.start || '',
                decision: parseInt(route.params.decision) ? STATUS_LIKE : STATUS_DISLIKE,
            };
        },
        meta,
    },
    {
        name: 'appointment-declined-invites',
        path: '/appointment/declined-invites',
        component: AppointmentDeclinedInvites,
        props(route: RouteLocationStringParam)
        {
            return {
                resource: 'appointment',
                id: parseInt(route.params.id),
                start: route.params.start || '',
                decision: parseInt(route.params.decision) ? STATUS_LIKE : STATUS_DISLIKE,
            };
        },
        meta,
    },
    {
        name: 'appointment-settings',
        path: '/appointment/settings/:route(intranet)?',
        component: AppointmentSettings,
        meta,
        alias: [
            '/appointment/settings/:route(intranet)?/:wildcard*',
        ],
        children: [
            {
                path: 'index',
                name: 'appointment-settings-global',
                component: AppointmentSettingsGlobal,
                meta,
            },
            {
                path: 'calendar/:id',
                name: 'appointment-settings-calendar',
                component: AppointmentCalendarEdit,
                props(route: RouteLocationStringParam)
                {
                    return {
                        type: 'calendar',
                        resource: 'appointment',
                        id: toInt(route.params.id),
                        isSettingsPage: true,
                    };
                },
                meta,
            },
            {
                path: 'visitor-list',
                name: 'appointment-settings-visitor-list',
                component: VisitorListSettings,
                meta,
            },
            {
                path: 'categories',
                name: 'appointment-settings-categories',
                component: CategoryManagement,
                props()
                {
                    return {
                        breadcrumbs: [
                            {
                                label: 'Veranstaltungen',
                                href: {name: 'event-list'},
                            },
                        ],
                        route: '/appointment/categories',
                        tag: 'div',
                    };
                },
                meta,
            },
        ],
    },

    // visitor list
    {
        name: 'visitor-list-view',
        path: '/appointment/visitor-list/view/:resource/:id/:start',
        component: VisitorListView,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
                start: route.params.start,
                resource: route.params.resource,
            };
        },
        meta,
    },
    {
        name: 'visitor-list-settings',
        path: '/appointment/settings/visitor-list',
        component: VisitorListSettings,
        meta,
    },
    {
        name: 'visitor-list',
        path: '/appointment/visitor-list/:module(enrolment|global)?',
        component: VisitorList,
        props(route: RouteLocationStringParam)
        {
            return {
                module: availableVisitorListModules.includes(route.params.module) ? route.params.module : 'global',
            };
        },
        meta,
    },
];

addCalendarRoutes(
    'appointment',
    routes,
    {
        calendarEdit: AppointmentCalendarEdit,
        entryEdit: AppointmentEntryEdit,
        entryView: AppointmentEntryView,
    },
);

export default routes;